module.exports = __webpack_public_path__ + "img/9f4bcdc9-59c1-4b4a-aa21-ff1907f7c890.e9d0a46a.jpg";